"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccountIdHolder = exports.useAccountId = exports.AccountIdHolderProvider = exports.AccountIdHolderContext = exports.useAccount = exports.AccountContextProvider = exports.AccountContext = void 0;
const react_1 = require("react");
exports.AccountContext = (0, react_1.createContext)(null);
exports.AccountContext.displayName = "AccountContext";
exports.AccountContextProvider = exports.AccountContext.Provider;
const useAccount = () => (0, react_1.useContext)(exports.AccountContext);
exports.useAccount = useAccount;
exports.AccountIdHolderContext = (0, react_1.createContext)(null);
exports.AccountIdHolderContext.displayName = "AccountIdHolderContext";
exports.AccountIdHolderProvider = exports.AccountIdHolderContext.Provider;
const noop = () => () => { };
/**
 * The local player id. Sourced from the AccountIdHolder, which the server
 * confirms on connect (so it matches whichever provider authenticated us -
 * guest, account, ...). Falls back to the auth context's id before connecting.
 */
const useAccountId = () => {
    var _a, _b, _c;
    const holder = (0, react_1.useContext)(exports.AccountIdHolderContext);
    const account = (0, exports.useAccount)();
    (0, react_1.useSyncExternalStore)((_a = holder === null || holder === void 0 ? void 0 : holder.subscribe) !== null && _a !== void 0 ? _a : noop, holder ? holder.getSnapshot : () => 0);
    return (_c = (_b = holder === null || holder === void 0 ? void 0 : holder.peek()) !== null && _b !== void 0 ? _b : account === null || account === void 0 ? void 0 : account.id) !== null && _c !== void 0 ? _c : "";
};
exports.useAccountId = useAccountId;
const useAccountIdHolder = () => {
    const holder = (0, react_1.useContext)(exports.AccountIdHolderContext);
    if (!holder) {
        throw new Error("useAccountIdHolder must be used inside AccountIdHolderProvider");
    }
    return holder;
};
exports.useAccountIdHolder = useAccountIdHolder;
